module.exports = __webpack_public_path__ + "static/media/small-dropdown-white-select.6f3eb95f.svg";